'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosHelpEmpty = function IoIosHelpEmpty(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20.3 28.6c-0.7 0-1.3-0.6-1.3-1.3s0.6-1.4 1.3-1.4 1.3 0.7 1.3 1.4-0.6 1.3-1.3 1.3z m2.7-9c-1.8 1.7-1.7 2.1-1.8 4.2h-1.5c0.1-2.2 0.5-3.4 2.3-5 0.9-0.8 1.5-1.9 1.5-3.1 0-1.9-1.5-3-3.3-3-2.5 0-3.8 1.2-3.7 3.6h-1.5c0-3.3 2-4.9 5.3-4.9 2.6 0 4.7 1.6 4.7 4.2 0 1.7-0.9 2.9-2 4z' })
        )
    );
};

exports.default = IoIosHelpEmpty;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-help-empty.js
// module id = 2415
// module chunks = 0